import React from "react";
import { getWeekColumnData } from "../../../../../utils/annual-planner-helpers";
import moment from "moment";
import { getMonthRange } from "./StatsCard";
import {
  getRestDayTargetData,
  getTargetData,
  isPlanInRange,
} from "../../../../../utils/nutrition-helpers";

const NutritionTargets = ({
  month,
  startingCalendarDay,
  numberOfWeeks,
  nutritionPlans,
  restDay = false,
}) => {
  const lastNutritionDate = nutritionPlans.length
    ? nutritionPlans[nutritionPlans.length - 1].utcEndDate
    : moment().utc().format("YYYYMMDD");

  const { monthFirstDay } = getMonthRange(month, startingCalendarDay);

  const hiddenPlans = moment(monthFirstDay).isAfter(
    moment(String(lastNutritionDate))
  );

  return (
    <div className="stats-card">
      {/* We map a column for each week, containing the weekly summary for the plan nutrition */}
      {Array.from(Array(numberOfWeeks).keys(), (weekNumber) => {
        const weekFirstDay = getWeekColumnData(
          month,
          startingCalendarDay,
          weekNumber
        );

        const weekLastDay = moment(weekFirstDay).add(6, "days");

        const startUtc = Number(weekFirstDay.format("YYYYMMDD"));
        const endUtc = Number(weekLastDay.format("YYYYMMDD"));

        // Filtering the current week nutrition plans from the Nutrition Plans array
        const currentWeekPlans = nutritionPlans.filter((plan) =>
          isPlanInRange(plan, startUtc, endUtc)
        );

        return (
          <NutritionColumn
            key={startUtc}
            currentWeekPlans={currentWeekPlans}
            hiddenPlans={hiddenPlans}
            weekFirstDay={String(startUtc)}
            weekLastDay={weekLastDay.add(1, "days").format("YYYYMMDD")}
            restDay={restDay}
          />
        );
      })}
    </div>
  );
};

const NutritionColumn = ({
  currentWeekPlans,
  hiddenPlans,
  weekFirstDay,
  weekLastDay,
  restDay,
}) => {
  const { proteinAvg, carbsAvg, fatAvg, fiberAvg, kCalAvg } = getWeeklyPlansAvg(
    currentWeekPlans,
    weekFirstDay,
    weekLastDay,
    restDay
  );

  return (
    <div className={`stats-column${hiddenPlans ? " hidden" : ""}`}>
      <span>{proteinAvg || "-"}</span>
      <span>{carbsAvg || "-"}</span>
      <span>{fatAvg || "-"}</span>
      <span>{fiberAvg || "-"}</span>
      <span>{kCalAvg || "-"}</span>
    </div>
  );
};

export const getWeeklyPlansAvg = (
  currentWeekPlans,
  weekFirstDay,
  weekLastDay,
  restDay
) => {
  const targetData = !restDay
    ? getTargetData({
        isPeriod: true,
        nutritionPlan: currentWeekPlans,
        startOfWeek: weekFirstDay,
        endOfWeek: weekLastDay,
        averageValues: true,
        isPlanCalendar: true,
      })
    : getRestDayTargetData(currentWeekPlans, weekFirstDay, weekLastDay, true);

  const {
    targetProteins,
    targetFats,
    targetCalories,
    targetCarbs,
    targetFibers,
  } = targetData;

  const proteinAvg = Math.round(targetProteins);
  const carbsAvg = Math.round(targetCarbs);
  const fatAvg = Math.round(targetFats);
  const fiberAvg = Math.round(targetFibers);
  const kCalAvg = Math.round(targetCalories);

  return { proteinAvg, carbsAvg, fatAvg, fiberAvg, kCalAvg };
};

export default NutritionTargets;
